import { LocationStrategy } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable, enableProdMode, inject } from "@angular/core";
import { Amplify } from "aws-amplify";
import { lastValueFrom } from "rxjs";
import { shareReplay } from "rxjs/operators";

interface Configuration {
  production: Boolean;
  backendUrl: String;
  amplifyConfig: Object;
  localBackend: Boolean;
  version: string;
  productURL: {
    acsis: String;
    afirsAnalytics: String;
    aircraftFleetView: String;
    aviationDW: String;
    clearPort: String;
    fleetWatch: String;
    fuelSense: String;
    aircraftSim: String;
  };
}

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private json: Configuration;
  private httpClient = inject(HttpClient);

  constructor(public locationStrategy: LocationStrategy) {}

  public async load(): Promise<Configuration> {
    if (!this.json) {
      console.log(
        "URL",
        this.locationStrategy.prepareExternalUrl("/assets/env/environment.json")
      );
      const json = await lastValueFrom(
        this.httpClient
          .get<Configuration>(
            this.locationStrategy.prepareExternalUrl(
              "/assets/env/environment.json"
            )
          )
          .pipe(shareReplay(1))
      );

      this.json = json;
    }

    this.initialize();

    return this.json;
  }

  public getJson() {
    return this.json;
  }

  private initialize() {
    Amplify.configure(this.json.amplifyConfig);

    if (this.json.production) {
      enableProdMode();
    }
  }
}
